export default __webpack_public_path__ + "static/media/unlimited-resources-icon.a695eb54.svg";